import "./assets/css/App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./auth/login/Login";
import Register from "./auth/login/Register";
import Reset from "./auth/login/Reset";
import Dashboard from "./Dashboard";
import CreateSnippet from "./pages/CreateSnippet";

import NavHeader from "./components/main/NavHeader";
import SmoothScroll from './components/main/ScrollTop';
import SingleSnippet from "./pages/SingleSnippet";
import SnippetList from "./pages/SnippetList";

function App() {
  return (
    <div className="app">
      <Router>
        <SmoothScroll/>
        <NavHeader/>
        <Routes>
          <Route exact path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset" element={<Reset />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/createSnippet" element={<CreateSnippet />} />
          <Route path="/snippet/:snippet" element={<SingleSnippet />} />
          <Route path="/snippets" element={<SnippetList />} />
        </Routes>
      </Router>
    </div>
  );
}
export default App;